import React from "react";
import { Box, Paper, Typography, Switch } from "@mui/material";
import { TEXT_COLOR_PRIMARY } from "../../constants/colors";

/**
 * 確認モーダル内で使用するトグル表示用コンポーネント
 *
 * @param {React.ReactNode} [icon] - 左側に表示するアイコン（任意）
 * @param {string} label - トグルのメインラベル
 * @param {string} [description] - ラベル下に表示する説明文（任意）
 * @param {boolean} value - トグルのON/OFF状態
 * @param {(checked: boolean) => void} onChange - トグル変更時の処理
 */
const ConfirmModalToggleRow = ({
  icon,
  label,
  description,
  value = false,
  onChange,
}) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Paper
        variant="outlined"
        sx={{
          borderRadius: 2,
          p: 2,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
        }}
      >
        {/* 上段（アイコン＋テキスト） */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            width: "100%",
          }}
        >
          {/* 左アイコン */}
          {icon && (
            <Box
              sx={{
                fontSize: 22,
                display: "flex",
                alignItems: "center",
              }}
            >
              {icon}
            </Box>
          )}

          {/* テキストエリア */}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontWeight: 700 }}>{label}</Typography>

            {description && (
              <Typography
                variant="body2"
                sx={{ color: TEXT_COLOR_PRIMARY, mt: 0.5 }}
              >
                {description}
              </Typography>
            )}
          </Box>
        </Box>

        {/* 下段（Switch） */}
        <Box
          sx={{
            width: { xs: "100%", sm: "auto" },
            display: "flex",
            justifyContent: { xs: "center", sm: "flex-end" },
          }}
        >
          <Switch
            checked={Boolean(value)}
            onChange={(e) => onChange?.(e.target.checked)}
            inputProps={{ "aria-label": label }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default ConfirmModalToggleRow;
